module.exports = __webpack_public_path__ + "static/img/ordermagengt.4005805.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ordermagengt.png
// module id = GzJR
// module chunks = 1